import { render, staticRenderFns } from "./OneSideComparison.vue?vue&type=template&id=f7a837a0&scoped=true&"
import script from "./OneSideComparison.vue?vue&type=script&lang=js&"
export * from "./OneSideComparison.vue?vue&type=script&lang=js&"
import style0 from "./OneSideComparison.vue?vue&type=style&index=0&id=f7a837a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a837a0",
  null
  
)

/* custom blocks */
import block0 from "./OneSideComparison.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7a837a0')) {
      api.createRecord('f7a837a0', component.options)
    } else {
      api.reload('f7a837a0', component.options)
    }
    module.hot.accept("./OneSideComparison.vue?vue&type=template&id=f7a837a0&scoped=true&", function () {
      api.rerender('f7a837a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/comparison/OneSideComparison.vue"
export default component.exports